import { render, staticRenderFns } from "./msgProibida.vue?vue&type=template&id=30827fd8&scoped=true"
import script from "./msgProibida.vue?vue&type=script&lang=js"
export * from "./msgProibida.vue?vue&type=script&lang=js"
import style0 from "./msgProibida.vue?vue&type=style&index=0&id=30827fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30827fd8",
  null
  
)

export default component.exports